module.exports = __webpack_public_path__ + "img/4_79.ea918e86.png";